var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { attrs: { title: _vm.title } },
    [
      _c(
        "div",
        {
          staticStyle: { display: "flex", "justify-content": "space-between" }
        },
        [
          [_vm._v("\n      " + _vm._s(_vm.extraContent) + "\n    ")],
          _vm._v(" "),
          !_vm.readonly
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.selectAllPermissions }
                },
                [_vm._v("全选")]
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, "span-method": _vm.objectSpanMethod }
        },
        [
          _c("el-table-column", {
            attrs: { label: "功能模块", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-checkbox",
                      {
                        key: scope.row.module.key,
                        attrs: {
                          disabled: _vm.readonly || scope.row.module.disabled,
                          indeterminate: scope.row.module.indeterminate
                        },
                        on: {
                          change: function($event) {
                            var i = arguments.length,
                              argsArray = Array(i)
                            while (i--) argsArray[i] = arguments[i]
                            return _vm.handleModuleCheckboxChange.apply(
                              void 0,
                              [scope.row].concat(argsArray)
                            )
                          }
                        },
                        model: {
                          value: scope.row.module.checked,
                          callback: function($$v) {
                            _vm.$set(scope.row.module, "checked", $$v)
                          },
                          expression: "scope.row.module.checked"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.module.title) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "一级分类", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-checkbox",
                      {
                        key: scope.row.firstCategory.key,
                        attrs: {
                          disabled:
                            _vm.readonly || scope.row.firstCategory.disabled,
                          indeterminate: scope.row.firstCategory.indeterminate
                        },
                        on: {
                          change: function($event) {
                            var i = arguments.length,
                              argsArray = Array(i)
                            while (i--) argsArray[i] = arguments[i]
                            return _vm.handleFirstCategoryCheckboxChange.apply(
                              void 0,
                              [scope.row].concat(argsArray)
                            )
                          }
                        },
                        model: {
                          value: scope.row.firstCategory.checked,
                          callback: function($$v) {
                            _vm.$set(scope.row.firstCategory, "checked", $$v)
                          },
                          expression: "scope.row.firstCategory.checked"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.firstCategory.title) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "二级分类" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "checkbox-container" },
                      _vm._l(
                        _vm.sortedSecondCategory(scope.row.secondCategory),
                        function(item) {
                          return _c(
                            "div",
                            { key: item.key },
                            [
                              item.children && item.children.length > 0
                                ? _c("el-tree", {
                                    ref: "tree-" + item.key,
                                    refInFor: true,
                                    staticClass: "my-tree",
                                    attrs: {
                                      data: item.treeData,
                                      "node-key": "key",
                                      "show-checkbox": "",
                                      "default-checked-keys": item.checkedKeys,
                                      disabled: _vm.readonly || item.disabled,
                                      "render-content": _vm.renderTreeNode
                                    },
                                    on: {
                                      check: function($event) {
                                        var i = arguments.length,
                                          argsArray = Array(i)
                                        while (i--) argsArray[i] = arguments[i]
                                        return _vm.handleSecondaryCategoryTreeNodeCheck.apply(
                                          void 0,
                                          [item.key].concat(argsArray)
                                        )
                                      }
                                    }
                                  })
                                : _c(
                                    "el-checkbox",
                                    {
                                      key: item.key,
                                      staticClass: "my-checkbox",
                                      attrs: {
                                        disabled: _vm.readonly || item.disabled,
                                        "node-key": "key"
                                      },
                                      on: {
                                        change: function($event) {
                                          var i = arguments.length,
                                            argsArray = Array(i)
                                          while (i--)
                                            argsArray[i] = arguments[i]
                                          return _vm.handleSecondaryCategoryCheckboxChange.apply(
                                            void 0,
                                            [scope.row, item.key].concat(
                                              argsArray
                                            )
                                          )
                                        }
                                      },
                                      model: {
                                        value: item.checked,
                                        callback: function($$v) {
                                          _vm.$set(item, "checked", $$v)
                                        },
                                        expression: "item.checked"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.title) +
                                          "\n            "
                                      )
                                    ]
                                  )
                            ],
                            1
                          )
                        }
                      ),
                      0
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.readonly
        ? _c(
            "div",
            { staticClass: "footer" },
            [
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v("取消")
              ]),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.handleReset } }, [
                _vm._v("重置")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("确认保存")]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-90750f34", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90750f34","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/positionPermissions/PermissionSelector.vue
// module id = null
// module chunks = 